<template>
    <v-container fluid>
        <div v-if="!loading">
            <v-row>
                <v-col>
                    <h4 class="text-h4">Supplier Payment #{{data.code}}</h4>
                    <p class="text-subtitle-1">Supplier Payment Information</p>
                    <v-divider></v-divider>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="3" v-if="hasPermission(perm.payment.post) && data.state_code == stateDraft">
                    <v-btn block color="primary" @click="handlePost">
                        <v-icon left>mdi-post</v-icon>
                        post
                    </v-btn>
                </v-col>
                <v-col cols="12" md="3">
                    <v-btn block :depressed="data && data.state_code != statePosted" :color="data && data.state_code == statePosted ? 'primary' : ''" @click="handlePrint">
                        <v-icon left>mdi-printer</v-icon>
                        print
                    </v-btn>
                </v-col>
                <v-col cols="12" md="3"  v-if="hasPermission(perm.payment.update) && data.state_code == stateDraft">
                    <v-btn block depressed @click="handleEdit">
                        <v-icon left>mdi-pencil</v-icon>
                        edit
                    </v-btn>
                </v-col>
                <v-col cols="12" md="3"  v-if="hasPermission(perm.payment.delete) && data.state_code == stateDraft">
                    <v-btn block depressed color="error--text" :loading="deleteLoading" @click="handleRemove">
                        <v-icon left>mdi-delete</v-icon>
                        delete
                    </v-btn>
                </v-col>
            </v-row>
            <v-row>
                <v-col>
                    <PurchasePayment :value="data"/>
                </v-col>
            </v-row>
        </div>
        <div v-else>
            <v-row>
                <v-col>
                    <v-skeleton-loader type="heading" class="my-4"/>
                    <v-skeleton-loader type="text" class="my-4"/>
                    <v-divider></v-divider>
                </v-col>
            </v-row>
            <v-row>
                <v-col class="d-flex">
                    <v-skeleton-loader type="button" class="my-4 me-4"/>
                    <v-skeleton-loader type="button" class="my-4"/>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="6">
                    <v-skeleton-loader type="text" class="my-4"/>
                    <v-skeleton-loader type="text" class="my-4"/>
                    <v-skeleton-loader type="text" class="my-4"/>
                    <v-skeleton-loader type="text" class="my-4"/>
                </v-col>
            </v-row>
            <v-row no-gutters>
                <v-col>
                    <v-skeleton-loader type="text" class="my-2"/>
                    <v-skeleton-loader type="text" class="my-2"/>
                    <v-skeleton-loader type="text" class="my-2"/>
                    <v-skeleton-loader type="text" class="my-2"/>
                    <v-skeleton-loader type="text" class="my-2"/>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="6">
                    <v-skeleton-loader type="text" class="my-2"/>
                    <v-skeleton-loader type="text" class="my-2"/>
                </v-col>
                <v-col cols="12" md="6">
                    <v-skeleton-loader type="text" class="my-2"/>
                    <v-skeleton-loader type="text" class="my-2"/>
                </v-col>
            </v-row>
            
        </div>
        <PAlert v-model="alert.value" v-bind="alert"/>
    </v-container>
</template>

<script>
import permissions from './../../data/permissions';
import PurchasePayment from './../../components/purchase/PurchasePayment.vue';
import PAlert from './../../components/common/PAlert.vue'
import { mapActions, mapGetters } from 'vuex';

export default {
    name: "PaymentDisplayView",
    components: {
        PurchasePayment,
        PAlert
    },
    data() {
        return {
            id: null,
            loading: false,
            deleteLoading: false,
            data: {},
            alert:{
                value: false,
                content: 'Are you sure?',
                callback: null
            },
            perm: permissions,
            stateDraft: 1,
            statePosted: 3
        }
    },
    computed: {
        ...mapGetters({
            hasPermission: "authentication/hasPermission"
        }),
    },
    methods: {
        ...mapActions({
            findByID: "purchase/payment/findByID",
            snackbar: "ui/snackbar/show",
            post: "purchase/payment/post",
            remove: "purchase/payment/remove",
            print: "purchase/payment/print",
        }),
        getAsync() {
            this.loading = true;
            this.findByID(this.id).then(response => {
                this.data = response.data;
            }).catch(error => {
                let message = error.response ? error.response.data.message : error;
                this.snackbar({color: "error", text: message});
            }).finally(() => {
                this.loading = false;
            })
        },
        handleCreate() {
            this.$router.push({ name: "PurchasePaymentCreate" });
        },
        handleList() {
            this.$router.push({ name: "PurchasePaymentList" })
        },
        handleEdit() {
            this.$router.push({ name: "PurchasePaymentEdit", params: { id: this.id } })
        },
        handlePost() {
            this.alert = {...this.alert, value: true, content: "Are you sure you want to post this payment?", callback: this.postAsnyc}
        },
        postAsnyc() {
            this.loading = true;
            this.post(this.data).then(response => {
                this.data = response.data;
                this.snackbar({color: "success", text: "Payment posted successfully"});
                setTimeout(this.getAsync, 2000)
            }).catch(error => {
                let message = error.response ? error.response.data.message : error;
                this.snackbar({color: "error", text: message});
            }).finally(() => {
                this.loading = false;
            })
        },
        handlePrint() {
            this.print(this.data)
                .then(response => {
                    var printWindow = window.open('','','width=800,height=600');
                    printWindow.document.write(response.data);
                    printWindow.document.close();
                    printWindow.focus();
                    printWindow.print();
                    printWindow.close();
                })
                .catch(error => {
                    let message = error.response ? error.response.data.message : error;
                    this.snackbar = { value: true, color: "error", text: message }
                });
        },
        removeAsync() {
            this.deleteLoading = true;
            this.remove(this.data).then(() => {
                this.snackbar({color: "success", text: "Payment Deleted Successfully"});
                this.$router.push({name: "PurchasePaymentList"})
            }).finally(() => {
                this.deleteLoading = false;
            })
        },
        handleRemove() {
            this.alert = {...this.alert, value: true, callback: this.removeAsync}
        },
    },
    created() {
        this.id = this.$route.params.id;
        this.getAsync();
    },
    beforeRouteUpdate(to, from, next) {
        this.id = to.params.id;
        this.getAsync();
        next();
    }
}
</script>

<style>

</style>